import React from 'react'
import PropTypes from 'prop-types'
import { ButtonIcon, Rows, Columns, Tooltip, CheckIcon } from 'src/components'
import { LocalizedText } from 'src/components/intl'
import { TimesIcon } from 'src/components/icons'
import styles from './TooltipConfirm.scss'

const TooltipConfirm = ({
  label,
  onConfirm,
  onCancel,
  hideOnConfirm,
  hideOnCancel,
  confirmLabel,
  cancelLabel,
  ...props
}) => (
  <Tooltip
    triggers={['click']}
    interactive
    overlay={hide => (
      <Confirm {...{ hide, label, onConfirm, onCancel, hideOnConfirm, hideOnCancel, confirmLabel, cancelLabel }} />
    )}
    {...props}
  />
)

TooltipConfirm.propTypes = {
  /** Main label to be displayed */
  label: PropTypes.node,
  /** Handler on click on confirm button */
  onConfirm: PropTypes.func,
  /** Handler on click on cancel button */
  onCancel: PropTypes.func,
  /** Whether or not to hide the tooltip on confirm */
  hideOnConfirm: PropTypes.bool,
  /** Whether or not to hide the tooltip on cancel */
  hideOnCancel: PropTypes.bool,
  /** Label to be displayed in confirm button */
  confirmLabel: PropTypes.node,
  /** Label to be displayed in cancel button */
  cancelLabel: PropTypes.node,
}

const Confirm = ({ label, onConfirm, onCancel, hideOnConfirm, hideOnCancel, confirmLabel, cancelLabel, hide }) => (
  <Rows justify="" align="" className={styles.container}>
    <span className={styles.label}>{label}</span>
    <Columns justify="center" align="center" className={styles.buttons}>
      <ButtonIcon
        icon={TimesIcon}
        color="danger"
        onClick={() => {
          hideOnCancel && hide()
          onCancel && onCancel(hide)
        }}
      >
        {cancelLabel}
      </ButtonIcon>
      <ButtonIcon
        icon={CheckIcon}
        color="success"
        onClick={() => {
          hideOnConfirm && hide()
          onConfirm && onConfirm(hide)
        }}
      >
        {confirmLabel}
      </ButtonIcon>
    </Columns>
  </Rows>
)

Confirm.defaultProps = {
  confirmLabel: <LocalizedText id="WEB_VALID" />,
  cancelLabel: <LocalizedText id="WEB_CANCEL" />,
  label: <LocalizedText id="WEB_CONFIRMATION" />,
}

Confirm.propTypes = {
  ...TooltipConfirm.propTypes,
  /** Method used to hide the tooltip */
  hide: PropTypes.func,
}

export default TooltipConfirm
